import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18Adminsetting = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M6.274 1.013a1.7 1.7 0 0 1 1.498.576 1.736 1.736 0 0 0 2.582.026l.12-.12c.282-.257.608-.397.94-.437.995-.123 2.029.65 1.958 1.833a1.74 1.74 0 0 0 1.808 1.844c1.638-.069 2.455 1.952 1.231 3.037a1.74 1.74 0 0 0-.026 2.582c1.123 1.031.467 2.835-.94 3.008a2 2 0 0 1-.336.01 1.74 1.74 0 0 0-1.844 1.808v.17c-.041.914-.751 1.54-1.54 1.637a1.7 1.7 0 0 1-1.497-.576 1.736 1.736 0 0 0-2.582-.026l-.12.12a1.7 1.7 0 0 1-.94.438c-.995.122-2.029-.65-1.958-1.834a1.74 1.74 0 0 0-1.808-1.844c-1.638.069-2.455-1.951-1.232-3.037a1.74 1.74 0 0 0 .027-2.582c-1.123-1.031-.467-2.835.94-3.008a2 2 0 0 1 .336-.01A1.74 1.74 0 0 0 4.736 2.82v-.17c.04-.914.75-1.54 1.538-1.637m1.49 4.925a3.304 3.304 0 1 0 2.475 6.126 3.304 3.304 0 0 0-2.476-6.126z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18Adminsetting$1 = Svg18Adminsetting;

export { Svg18Adminsetting$1 as default };
